var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-container-outer"},[_c('div',{staticClass:"loading-container-inner"},[_c('vue-loading',{attrs:{"type":"beat","color":"#3081c0","size":{ width: '75px', height: '75px' }}})],1),_c('p',[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }